export const light = {
  alternate: {
    main: '#f7faff',
    dark: '#edf1f7'
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  mode: 'light',
  primary: {
    light: '#818c61',
    main: '#62703A',
    dark: '#444e28',
    contrastText: '#fff'
  },
  secondary: {
    light: '#449a9f',
    main: '#168187',
    dark: '#0f5a5e',
    contrastText: '#fff'
  },
  text: {
    primary: '#1e2022',
    secondary: '#677788'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    level2: '#f5f5f5',
    level1: '#ffffff'
  }
}

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30'
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff'
  },
  mode: 'dark',
  primary: {
    light: '#88c4c7',
    main: '#6bb6ba',
    dark: '#168187',
    contrastText: '#000000'
  },
  secondary: {
    light: '#adba39',
    main: '#99A908',
    dark: '#6b7605',
    contrastText: '#000000'
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222B45',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748'
  }
}
